import { useEffect, useState } from "react";
import { KeyRound } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../../components/ui/dialog";
import { useAuth } from "../../store/AuthContext";
import { api } from "../../lib/api";
import { PasswordForm } from "./PasswordForm";

// Pops up once, the next time an email-code customer opens the app: put a password on the account so the code isn't needed
// every time. "Not now" never asks again — the dashboard still offers it.
export const PasswordPromptDialog = () => {
  const { user, previewAs } = useAuth();
  const [open, setOpen] = useState(false);
  const due = Boolean(user && !previewAs && user.password_prompt && !user.viewing_as);
  useEffect(() => {
    if (!due || sessionStorage.getItem("xpattern.pwPrompt")) return;
    // mark as shown inside the timer — React StrictMode (dev) runs effects twice and the cleanup cancels the first timer
    const t = setTimeout(() => { sessionStorage.setItem("xpattern.pwPrompt", "1"); setOpen(true); }, 1500);  // let the workspace settle first
    return () => clearTimeout(t);
  }, [due]);
  if (!due) return null;
  const later = () => { setOpen(false); api.passwordLater().catch(() => {}); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) later(); }}>
      <DialogContent className="panel3d max-w-md border-[#4c9ffe]/40 bg-[#121824] text-[#e8e9ec]" data-testid="password-prompt-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-[16px] text-[#8fc2ff]"><KeyRound className="h-5 w-5" /> Skip the email code next time</DialogTitle>
          <DialogDescription className="text-[13px] leading-relaxed text-[#c7cbd1]">
            Put a password on your account and sign in with your email + password from now on. The email code keeps working too — if you ever forget the password, sign in with the code and set a new one from My Dashboard.
          </DialogDescription>
        </DialogHeader>
        <PasswordForm testId="password-prompt-form" onDone={() => setOpen(false)} />
        <button data-testid="password-prompt-later-btn" onClick={later} className="w-full text-center text-[12px] text-[#9aa0a8] hover:text-[#e8e9ec]">Not now — keep using the email code</button>
      </DialogContent>
    </Dialog>
  );
};
